import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Formik } from 'formik';
import { Field } from "formik";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { KEY } from 'web/components/utils/stripeKey';
import AddCard from './Credit-Card';
import Button from 'web/components/Button';
import ACHForm from 'web/components/ACHForm';
import RadioButton from "web/components/form-elements/RadioButton";
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import AlertModal from 'web/components/AlertModal';
import Spinner from 'web/components/Spinner';
import './popup.scss';

export default ({ isOpen, modalType, toggle, title, pageData, callBackModal, callBackFetchApi, content, onClickHander, pageLanguageContents }) => {
  const stripePromise = loadStripe(KEY);
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState();
  const [modalLink, setModalLink] = useState();
  const toggleModal = () => setModal(!modal);

  const [acccontType, setAcccontType] = useState("");

  const [radioTypes, setRadioTypes] = useState([])

  useEffect(() => {
    setRadioTypes([
      {
        value: "bankAccount",
        label: "ACH",
      },
      {
        value: "creditCard",
        label: "Card",
      }
    ])
    // ach can be added only if atleast one card is already added
    // also, for guest users ach option is not given
    if (pageData?.userDetails && (pageData?.buyerPaymentDetails?.cardDetails?.length > 0 && pageData?.userDetails?.userRole !== 'GUEST')) setAcccontType('bankAccount')
    else setAcccontType('creditCard')
  }, [isOpen])

  const onChangeHandler = (e, props, setFieldValue) => {
    const { setTouched, validateForm, isValid } = props;
    validateForm();
    setTouched({});
    if (pageData?.buyerPaymentDetails?.cardDetails?.length > 0) {
      props.setFieldValue('accountType', e.target.value)
      setAcccontType(e.target.value);
    } else if (e.target.value !== 'creditCard') {
      props.setFieldValue('accountType', 'creditCard')
      setAcccontType('creditCard');
      setModalContent('Please add a card before adding ACH account.');
      toggleModal();
    } else {
      props.setFieldValue('accountType', 'creditCard')
      setAcccontType('creditCard');
    }
  };

  const getRegisterInitialValues = (obj) => {
    return {
      accountType: pageData?.buyerPaymentDetails?.cardDetails?.length > 0 ? 'bankAccount' : 'creditCard'
    }
  }

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='card-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              toggle(!isOpen)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>{(modalType === "buyerPaymentDetailsAdd" && (pageData?.userDetails && pageData?.userDetails?.userRole !== 'GUEST')) ? "ACH/" : ""}Card Details</h3>
          </div>
          <ModalBody>
            {loaderVisible && <Spinner />}
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>
            <div className='modal-content'>
              {(content && content !== '') && <h6 className='my-2 mb-4'>{content}</h6>}

              {modalType === "buyerPaymentDetailsAdd" ?
                <Formik
                  validateOnMount
                  enableReinitialize={true}
                  initialValues={getRegisterInitialValues()}
                  onSubmit={(values) => { }}
                >
                  {(props) => {
                    const { setFieldValue } = props;
                    return (
                      <Form className="form">
                        <div><div class="app-input-text"></div></div>
                        {(pageData?.userDetails && pageData?.userDetails?.userRole !== 'GUEST') &&
                          <div className="col-12 displayFlex">
                            <div>
                              {radioTypes?.map((value, index) => (
                                <div key={index}>
                                  <Field
                                    component={RadioButton}
                                    name="accountType"
                                    className="radio-label"
                                    id={value.value}
                                    defaultValue={pageData?.buyerPaymentDetails?.cardDetails?.length > 0 ? radioTypes[0].value : radioTypes[1].value}
                                    onSelect={(e) => onChangeHandler(e, props, setFieldValue)}
                                    label={value.label}
                                    checked={value.value === acccontType}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        }
                        {acccontType === "bankAccount" &&
                          <Elements stripe={stripePromise}> <ACHForm props={props} callBackModal={callBackModal} callBackFetchApi={callBackFetchApi} /></Elements>}
                        {acccontType === "creditCard" && <AddCard
                          modalType={modalType}
                          pageData={pageData}
                          callBackModal={callBackModal}
                          callBackFetchApi={callBackFetchApi}
                          callBack={() => {
                            onClickHander()
                          }}
                          pageLanguageContents={pageLanguageContents}
                        />
                        }
                      </Form>
                    );
                  }}
                </Formik>
                :
                <AddCard
                  modalType={modalType}
                  callBackModal={callBackModal}
                  callBackFetchApi={callBackFetchApi}
                  callBack={() => {
                    onClickHander()
                  }}
                  pageLanguageContents={pageLanguageContents}
                />
              }
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
          </ModalFooter>
        </div>
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title=''
          alertType=''
          callBackAlert={() => { }}
          content={modalContent}
          link={modalLink}
        />
      </Modal>
    </div>
  );
};